import magicBrain from '../assets/magic_brain.jpg';
import myFlixClient from '../assets/myflix_client.jpg';
import croireetobeir from '../assets/croireetobeir.png';

export default function useImages() {
  return {
    magicBrain,
    myFlixClient,
    croireetobeir
  }
}